"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#A8ACBD",
  fillRule: "evenodd",
  d: "M5.948 14.375C4.32 14.375 3 12.993 3 11.287 3 9.582 4.32 8.2 5.948 8.2c.264 0 .518.04.761.107.496-1.535 1.87-2.646 3.497-2.679l.037-.002.038-.001c1.926 0 3.514 1.513 3.742 3.467a2.44 2.44 0 0 1 .435-.042c1.404 0 2.542 1.192 2.542 2.662s-1.138 2.663-2.542 2.663h-8.51Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CloudIcon20.js.map